import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiSendMailMessage } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiSendMailMessageDialogData {
  send_mail_messages?: ApiSendMailMessage[];
}

@Component({
  selector: 'app-multi-send-mail-message-dialog',
  templateUrl: './multi-send-mail-message-dialog.component.html',
  styleUrls: ['./multi-send-mail-message-dialog.component.css'],
  standalone: false,
})
export class MultiSendMailMessageDialogComponent implements OnInit {

  //FAQ×言語数
  sendMailMessages: ApiSendMailMessage[] = [];
  sendMailMessagesFormGroup!: FormGroup;
  sendMailMessagesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiSendMailMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiSendMailMessageDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.sendMailMessages = this.data.send_mail_messages!;
    if (!this.sendMailMessages) {
      this.sendMailMessages = [];
    }
    this.createForm();
    this.sendMailMessagesArrayControl = this.sendMailMessagesFormGroup.get('sendMailMessages') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.sendMailMessagesFormGroup.disable();
    }
  }

  //FAQフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.sendMailMessages.length ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let send_mail_message = '';
      let trans_send_mail_message = '';
      for (const value of this.sendMailMessages) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          send_mail_message = value.send_mail_message;
          trans_send_mail_message = value.trans_send_mail_message;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          sendMailMessage: [send_mail_message],
          transSendMailMessage: [trans_send_mail_message],
        }
      ));
      index++;
    }
    this.sendMailMessagesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        sendMailMessages: arrayControl
      }
    );
  }

  //更新ボタン
  addSendMailMessages(): void {
    if (this.sendMailMessagesFormGroup.valid) {
      let sendMailMessages = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.sendMailMessagesArrayControl.controls[index];
        sendMailMessages.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            send_mail_message: ctrl.get('sendMailMessage')!.value,
            trans_send_mail_message: ctrl.get('transSendMailMessage')!.value,
          }
        )
      }
      this.sendMailMessages = sendMailMessages;
      this.dialogRef.close(this.sendMailMessages);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.sendMailMessagesFormGroup.get('autoAllTrans')!.value;
    for (const sendMailMessage of this.sendMailMessagesArrayControl.controls) {
      sendMailMessage.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.sendMailMessagesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const sendMailMessage of this.sendMailMessagesArrayControl.controls) {
      if (!sendMailMessage.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.sendMailMessagesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
